import { FormFieldTypes } from "../../../../../../../data/formFieldType";

const initialState = {
  lClientKey: null,
  lContractTypeKey: null,
  lInstallmentTypeID: null,
  Dterminationdate:  new Date(),
  dtDateEffective: null
};

export const newContractConfig = {
  name: "Add Department",
  initialState: initialState,
  section: [
    {
      sectionId: "newContractSection",
      title: "Billing Address Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className=""></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "lClientKey",
          label: "Client :",
          Field_Name: "lClientKey",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lClientKey",
          fieldSetting: {
            placeholder: "Select Client Name",
            isEnableOnChange: true,
            options: [{ label: '', value: '' }]
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
        {
          id: "lContractTypeKey",
          label: "Contract Type :",
          Field_Name: "Contract Type",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lContractTypeKey",
          fieldSetting: {
            placeholder: "Select Contract Type",
            isEnableOnChange: true,
            options: [{ label: '', value: '' }]
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
        {
          id: "lInstallmentTypeID",
          label: "Invoice Frequency :",
          Field_Name: "Contract Type",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lInstallmentTypeID",
          fieldSetting: {
            placeholder: "Select Contract Type",
            isEnableOnChange: true,
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
        {
          id: "dtDateEffective",
          label: "Effective Date :",
          Field_Name: "Effective Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dtDateEffective",
          fieldSetting: {
            placeholder: "To",
            subTitle: " ",
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2 po-to-datepicker po-input",
          },
        },
        {
          id: "PurchaseOrderNumber",
          label: "Purchase Order# :",
          Field_Name: "Purchase Order",
          fieldType: FormFieldTypes.INPUT,
          dataField: "PurchaseOrderNumber",
          fieldSetting: {
            placeholder: "Instrument Type",
            isEnableOnChange: true,
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
        {
          id: "contractlength",
          label: "Contract Length (months) :",
          Field_Name: "Contract Length",
          fieldType: FormFieldTypes.INPUT,
          dataField: "contractlength",
          fieldSetting: {
            placeholder: "Model",
            isEnableOnChange: true,
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
        {
          id: "Dterminationdate",
          label: "Termination Date :",
          Field_Name: "termination date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "Dterminationdate",
          fieldSetting: {
            placeholder: "Enter Termination Date",
            allowSpace: true,
            isDisable: true,
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-lg-6 col-md-4 col-4 mb-2",
          },
        },
        {
          id: "contractName",
          label: "Contract Name :",
          Field_Name: "Contract name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "contractName",
          fieldSetting: {
            placeholder: "Contract Name",
            isEnableOnChange: true,
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
      ],
    },
  ],
};
